import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './categories/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ticket-categories'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'ticket_categories_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'ticket_categories_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'ticket_categories_list',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
